'use client';
import { jsx } from 'react/jsx-runtime';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(o = 0; o < s.length; o++)r = s[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, s = Object.keys(e);
    for(o = 0; o < s.length; o++)r = s[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const BaseTile = renderWithRef('BaseTile', null, (r, s)=>{
    useComponentStylesLoaded('BaseTile', SWAN_STYLE_KEY_MAP.baseTile);
    let { children: i, evenHeight: a = false, skin: l = 'standard' } = r, p = _object_without_properties(r, [
        "children",
        "evenHeight",
        "skin"
    ]), c = new Set([
        'swan-base-tile',
        `swan-base-tile-skin-${l}`
    ]);
    return a && c.add("swan-base-tile-even-height"), jsx(RenderComp, {
        root: "div",
        forwardedRef: s,
        classNames: c,
        props: p,
        children: i
    });
});

export { BaseTile };
